<template>
  <el-dialog
    title="修改账户提现"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="editAccountWithdrawalApplyInfo" label-width="120px">
      <el-form-item label="提现金额" prop="amount">
        <el-input
          v-model="editAccountWithdrawalApplyInfo.amount"
          placeholder="必填，请填写提现金额"
        />
      </el-form-item>
      <el-form-item label="申请人ID" prop="applyUserId">
        <el-input
          v-model="editAccountWithdrawalApplyInfo.applyUserId"
          placeholder="必填，请填写申请人ID"
        />
      </el-form-item>
      <el-form-item label="申请人名称" prop="applyUserName">
        <el-input
          v-model="editAccountWithdrawalApplyInfo.applyUserName"
          placeholder="必填，请填写申请人名称"
        />
      </el-form-item>
      <el-form-item label="申请人电话" prop="applyUserTel">
        <el-input
          v-model="editAccountWithdrawalApplyInfo.applyUserTel"
          placeholder="必填，请填写申请人电话"
        />
      </el-form-item>
      <el-form-item label="申请说明" prop="context">
        <el-input
          v-model="editAccountWithdrawalApplyInfo.context"
          type="textarea"
          placeholder="必填，请填写申请说明"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="editAccountWithdrawalApply">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { upAccountWithdrawalApply } from '@/api/goods/accountWithdrawalApplyApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditAccountWithdrawalApply',
  data() {
    return {
      dialogVisible: false,
      editAccountWithdrawalApplyInfo: {
        applyId: '',
        amount: '',
        applyUserId: '',
        applyUserName: '',
        applyUserTel: '',
        context: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(data) {
      this.editAccountWithdrawalApplyInfo = { ...data }
      this.editAccountWithdrawalApplyInfo.shopId = getShopId()
      this.dialogVisible = true
    },
    handleClose() {
      this.resetForm()
    },
    resetForm() {
      this.editAccountWithdrawalApplyInfo = {
        applyId: '',
        amount: '',
        applyUserId: '',
        applyUserName: '',
        applyUserTel: '',
        context: '',
        shopId: ''
      }
    },
    async editAccountWithdrawalApply() {
      if (!this.validateForm()) {
        return
      }
      try {
        const res = await upAccountWithdrawalApply(this.editAccountWithdrawalApplyInfo)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error(error)
      }
    },
    validateForm() {
      if (!this.editAccountWithdrawalApplyInfo.amount) {
        this.$message.error('提现金额不能为空')
        return false
      }
      if (!this.editAccountWithdrawalApplyInfo.applyUserId) {
        this.$message.error('申请人ID不能为空')
        return false
      }
      if (!this.editAccountWithdrawalApplyInfo.applyUserName) {
        this.$message.error('申请人名称不能为空')
        return false
      }
      if (!this.editAccountWithdrawalApplyInfo.applyUserTel) {
        this.$message.error('申请人电话不能为空')
        return false
      }
      if (!this.editAccountWithdrawalApplyInfo.context) {
        this.$message.error('申请说明不能为空')
        return false
      }
      return true
    }
  }
}
</script>